"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorldConfiguration = void 0;
const validation_1 = require("../../validation");
/** @alpha */
var WorldConfiguration;
(function (WorldConfiguration) {
    WorldConfiguration.schema = {
        type: 'object',
        properties: {
            name: {
                type: 'string',
                nullable: true
            },
            skybox: {
                type: 'number',
                nullable: true
            },
            minimapVisible: {
                type: 'boolean',
                nullable: true
            },
            miniMapConfig: {
                type: 'object',
                nullable: true,
                properties: {
                    visible: {
                        type: 'boolean',
                        nullable: true
                    },
                    dataImage: {
                        type: 'string',
                        nullable: true
                    },
                    estateImage: {
                        type: 'string',
                        nullable: true
                    }
                }
            },
            skyboxConfig: {
                type: 'object',
                nullable: true,
                properties: {
                    fixedTime: {
                        type: 'number',
                        nullable: true
                    },
                    textures: {
                        type: 'array',
                        nullable: true,
                        items: { type: 'string' },
                        oneOf: [
                            {
                                minItems: 0,
                                maxItems: 0
                            },
                            {
                                minItems: 1,
                                maxItems: 1
                            },
                            {
                                minItems: 6,
                                maxItems: 6
                            }
                        ],
                        errorMessage: 'customSkybox must be an array of 0, 1 or 6 strings'
                    }
                }
            },
            fixedAdapter: {
                type: 'string',
                nullable: true
            },
            placesConfig: {
                type: 'object',
                nullable: true,
                properties: {
                    optOut: {
                        type: 'boolean',
                        nullable: true
                    }
                }
            }
        },
        required: []
    };
    WorldConfiguration.validate = (0, validation_1.generateLazyValidator)(WorldConfiguration.schema);
})(WorldConfiguration = exports.WorldConfiguration || (exports.WorldConfiguration = {}));
//# sourceMappingURL=world-configuration.js.map